import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "font-gordita-medium text-[16px] text-Text/text_high leading-[18px]" }
const _hoisted_2 = { class: "flex flex-col gap-[13px]" }
const _hoisted_3 = {
  key: 0,
  class: "!leading-normal font-gordita-medium text-[11px]"
}

import { IncrediTooltip } from 'incredi-ui';
import COLORS from '@/design-system/colors.json';
import { ref } from 'vue';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'dashboard-chart-title',
  props: {
    tooltip: null,
    absolute: { type: Boolean }
  },
  setup(__props: any) {


const tooltipOpen = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex z-10", {
      'top-[19px] absolute': __props.absolute,
    }])
  }, [
    _createElementVNode("h2", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    (__props.tooltip && __props.tooltip.length > 0)
      ? (_openBlock(), _createBlock(_unref(IncrediTooltip), {
          key: 0,
          modelValue: tooltipOpen.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tooltipOpen).value = $event)),
          direction: "top-middle",
          delay: 200,
          hover: "",
          "offset-y": 5
        }, {
          content: _withCtx(() => [
            _createVNode(IbxScopedCss, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tooltip, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      (item.title)
                        ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(item.title), 1))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.isArray(item.description) ? item.description : [item.description], (description, descriptionIndex) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: descriptionIndex,
                          class: "font-gordita-regular text-[11px]"
                        }, _toDisplayString(description), 1))
                      }), 128))
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("i", {
              class: "uil uil-info-circle text-[16px] ml-[5px] relative bottom-[4px]",
              style: _normalizeStyle({ color: _unref(COLORS)['Text/text_medium'] })
            }, null, 4), [
              [_vShow, !tooltipOpen.value]
            ]),
            _withDirectives(_createElementVNode("i", {
              class: "uis uis-info-circle text-[16px] ml-[5px] relative bottom-[4px]",
              style: _normalizeStyle({ color: _unref(COLORS)['Text/text_medium'] })
            }, null, 4), [
              [_vShow, tooltipOpen.value]
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})